import React from 'react'
import { classNames } from './../../../utils/styles'
import PropTypes from 'prop-types'
import styles from './Option.scss'

function Option({
  id,
  type,
  label,
  checked = false,
  hasError,
  disabled,
  onChange,
  onFocus,
  onBlur,
  name,
  value,
  inline,
}) {
  function handleChange(event) {
    if (onChange == null) {
      return
    }
    onChange(event)
  }

  const isChecked = Boolean(checked)

  const wrapperClassName = classNames(
    styles.Checkbox,
    isChecked && styles.Checked,
    inline && styles.Inline,
    hasError && styles.Error,
  )
  const inputClassName = classNames(styles.Input)

  return (
    /* eslint-disable jsx-a11y/no-redundant-roles, jsx-a11y/role-has-required-aria-props */
    <label className={wrapperClassName} htmlFor={id}>
      <input
        id={id}
        name={name}
        value={value}
        type={type}
        checked={isChecked}
        disabled={disabled}
        className={inputClassName}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        aria-invalid={!hasError}
        role="checkbox"
      />
      {label}
    </label>
    /* eslint-disable jsx-a11y/no-redundant-roles, jsx-a11y/role-has-required-aria-props */
  )
}

export default Option

Option.propTypes = {
  id: PropTypes.any,
  type: PropTypes.any,
  label: PropTypes.any,
  labelHidden: PropTypes.any,
  helpText: PropTypes.any,
  checked: PropTypes.any,
  disabled: PropTypes.any,
  onChange: PropTypes.any,
  onFocus: PropTypes.any,
  onBlur: PropTypes.any,
  name: PropTypes.any,
  value: PropTypes.any,
  hasError: PropTypes.any,
  inline: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Form/Option/index.js